export const formatPrice = (price) => {
  // Si price es null, undefined, una cadena vacía o no es convertible a número, muestra 'Precio no disponible'
  if (price === null || price === undefined || price === '' || isNaN(Number(price))) {
    return 'Precio no disponible';
  }
  // return `S/. ${Number(price).toFixed(2)}`
  return `S/. ${Number(price).toLocaleString('es-PE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,})}`;
};
